import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { FiClock, FiArrowLeft, FiUser, FiArrowRight } from 'react-icons/fi';
import SeoHead from '../components/SeoHead';
import { useContent } from '../context/ContentContext';
import './BlogDetailPage.css';

const BlogDetailPage = () => {
  const { slug } = useParams();
  const { blogs, ready } = useContent();

  if (!ready) {
    return (
      <header className="page-header">
        <div className="container"><p>Loading article…</p></div>
      </header>
    );
  }

  const post = blogs.find((b) => (b.slug || b.id) === slug);
  if (!post) return <Navigate to="/resources/blog" replace />;

  const others = blogs.filter((b) => (b.slug || b.id) !== slug).slice(0, 3);
  const paragraphs = Array.isArray(post.content) ? post.content : (post.content ? [post.content] : []);

  return (
    <>
      <SeoHead title={post.title} description={post.excerpt} image={post.cover} path={`/resources/blog/${slug}`} />

      <article className="post">
        <div className="post-cover">
          {post.cover ? (
            <img src={post.cover} alt={post.title} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          ) : (
            <div className="post-cover-placeholder" />
          )}
        </div>

        <div className="container post-wrap">
          <Link to="/resources/blog" className="post-back">
            <FiArrowLeft /> All articles
          </Link>

          <span className="blog-category post-cat">{post.category}</span>
          <h1>{post.title}</h1>
          <div className="post-meta">
            {post.author && <span><FiUser /> {post.author}</span>}
            <span>{post.date}</span>
            {post.readTime && <span><FiClock /> {post.readTime}</span>}
          </div>

          {post.excerpt && <p className="post-lead">{post.excerpt}</p>}

          <div className="post-body">
            {paragraphs.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>

          {post.tags?.length > 0 && (
            <div className="post-tags">
              {post.tags.map((t) => <span key={t}>#{t}</span>)}
            </div>
          )}
        </div>
      </article>

      {others.length > 0 && (
        <section className="section section--alt">
          <div className="container">
            <div className="section-header">
              <span className="section-eyebrow">More reading</span>
              <h2 className="section-title section-title--center">Keep exploring.</h2>
            </div>
            <div className="post-related">
              {others.map((p) => (
                <Link key={p.id} to={`/resources/blog/${p.slug || p.id}`} className="post-related-card">
                  <span className="blog-category">{p.category}</span>
                  <h3>{p.title}</h3>
                  <span className="post-related-link">Read <FiArrowRight /></span>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default BlogDetailPage;
